import React from 'react'
export const UpsideDownVCompImg = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="249" height="247" viewBox="0 0 249 247" fill="none">
  <path d="M247.436 246.04L124.634 1.58411L1.83203 246.04M179.447 246.04L124.931 137.849L70.416 246.04" stroke="black" strokeWidth="3" strokeLinejoin="round"/>
</svg>
  )
}
